import { render, staticRenderFns } from "./ComponentsList.vue?vue&type=template&id=1cfdbfaa&scoped=true&"
import script from "./ComponentsList.vue?vue&type=script&lang=js&"
export * from "./ComponentsList.vue?vue&type=script&lang=js&"
import style0 from "./ComponentsList.vue?vue&type=style&index=0&id=1cfdbfaa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfdbfaa",
  null
  
)

export default component.exports